var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mero-place"},[_c('span',{staticClass:"mero-place__title"},[_vm._v(" "+_vm._s(_vm.$tr('event.madeOn')))]),_c('div',{staticClass:"mero-place__logo"},[_c('IconMeroPlace')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }